export const pages = {
    firstPage: 0,
    secondPage: 1,
};
